export const newDataSources = (dataSources) => {
  return { type: 'NEW_DATA_SOURCES', payload: dataSources };
};

export const newDataSource = (dataSource) => {
  return { type: 'NEW_DATA_SOURCE', payload: dataSource };
};

export const deleteDataSource = (dataSource) => {
  return { type: 'DELETE_DATA_SOURCE', payload: dataSource };
};

export const updateDataSource = (dataSource) => {
  return { type: 'UPDATE_DATA_SOURCE', payload: dataSource };
};
